<template>
  <div>
    <el-card>
      <el-table
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        class="menuTable"
        tooltip-effect="dark"
        :data="menuList"
        border
        style="width: 100%;margin-top:20px;"
      > 
        <el-table-column prop="title" label="导航名称" min-width="40%"></el-table-column>
        <el-table-column show-overflow-tooltip prop="enabled" label="状态" align="center" min-width="25%">
          <template slot-scope="scope">
            <el-switch
              v-if="scope.row.foreverExist!=1"
              v-model="scope.row.enabled"
              :active-value=1
              :inactive-value=-1
              @change="updateSwitching(scope.row)"
              class="switchStyle"
            ></el-switch>
            <div v-else>展示</div>
          </template>
        </el-table-column>
        <el-table-column min-width="25%" label="操作" align="center">
          <template slot-scope="scope">
            <el-link type="primary" v-if="scope.row.title=='课程中心'||scope.row.title=='师资团队'||scope.row.title=='关于我们'" 
            @click="toPage(scope.row.title)">管理</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="table_bottom" v-show="false">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          style="margin-top: 20px;text-align: left;"
          background
          layout="prev, pager, next, jumper,  total, sizes"
          :total="page.total"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
        ></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";


export default {
  data() {
    return {
       ids: [],
       page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: ""
      },
      menuList:[],
      searchForm: {
      },
      loading:false
    };
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData() {
      return this.$store.state.user;
    }
  },
  methods: {
    pageList() {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.api.schoolPage
        .menuPageList(this.searchForm)
        .then(result => {
          this.menuList = result.data.records;
          this.page.total = result.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    updateSwitching(row) {
      // console.log(row)
      this.api.schoolPage
        .menuSwitch({ id: row.id,enabled: row.enabled})
        .then(result => {
          if (result.success) {
            this.$message({
              type: "success",
              message: result.message
            });
            this.pageList();
          } else {
            this.$message({
              type: "error",
              message: result.message
            });
            this.pageList();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    toPage(title){
      if(title=='课程中心'){
        this.$router.push({ path: "/goodsInfo" });
      }
      if(title=='师资团队'){
        this.$router.push({ path: "/information" });
      }
      if(title=='关于我们'){
        this.$router.push({ path: "/setting" ,query:{activeType:'AI'}});
      }
    }
  },
  watch: {

  },
  mounted() {
    this.pageList();
  }
};
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/components/schoolPage/menuSetting.vue